import { Search } from '@mui/icons-material';
import { Button, InputAdornment, TextField } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useNavigate } from 'react-router';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { MuiSelect } from '/@/mui/select';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import { reverse } from '/@/utils/router';
import type { FieldSelectState } from './use-field-select';

type FieldSelectToolbarProps = Pick<
    FieldSelectState,
    | 'fieldName'
    | 'setFieldName'
    | 'debouncedFieldName'
    | 'fieldList'
    | 'showGrowersFields'
    | 'growersQuery'
    | 'selectedUserNodeId'
    | 'setSelectedUserNodeId'
    | 'hasNoGrowers'
    | 'ownNodeQuery'
    | 'setNewFieldModalOpen'
>;

function FieldSelectToolbar({
    fieldName,
    setFieldName,
    debouncedFieldName,
    fieldList,
    showGrowersFields,
    growersQuery,
    selectedUserNodeId,
    setSelectedUserNodeId,
    hasNoGrowers,
    ownNodeQuery,
    setNewFieldModalOpen,
}: FieldSelectToolbarProps) {
    const navigate = useNavigate();

    const handleToolbarAddField = () => {
        if (settings.app.theme === 'expertobayer') {
            setNewFieldModalOpen(true);
            return;
        }
        mpTrackEvent('Field create began', { entry_source: 'recommendation-create' });
        navigate(reverse('fields.NewField'));
    };

    return (
        <Grid2 container spacing={2} width='100%' alignItems='center' wrap='nowrap'>
            <Grid2 sx={{ flex: 1, minWidth: 0 }}>
                <TextField
                    label={_('Buscar lote por nombre')}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position='start'>
                                <Search fontSize='24px' />
                            </InputAdornment>
                        ),
                    }}
                    onChange={(e) => setFieldName(e.target.value)}
                    value={fieldName}
                    fullWidth
                    variant='outlined'
                    color='secondary'
                    disabled={!fieldList.length && !debouncedFieldName}
                />
            </Grid2>
            {showGrowersFields && (
                <Grid2 sm={4} sx={{ minWidth: 0, flex: '0 1 auto' }} className='mp-mask'>
                    <MuiSelect
                        value={selectedUserNodeId}
                        onChange={(e) => {
                            const next = e.target.value;
                            setSelectedUserNodeId(next === '' || next == null ? null : Number(next));
                        }}
                        type='number'
                        inputLabel={_('Productor')}
                        options={(growersQuery.data?.results || []).map((grower) => ({
                            label: grower.isSelf ? _('Mi cuenta') : grower.name,
                            value: grower.id.toString(),
                        }))}
                        formControlProps={{ fullWidth: true }}
                        clearable
                    />
                </Grid2>
            )}
            <Grid2 sx={{ flex: '0 0 auto', height: '100%' }}>
                <Button
                    variant='contained'
                    color='secondary'
                    disabled={hasNoGrowers}
                    onClick={handleToolbarAddField}
                    loading={ownNodeQuery.isValidating}
                    sx={{ height: '100%' }}
                >
                    {_('Agregar lote')}
                </Button>
            </Grid2>
        </Grid2>
    );
}

export default FieldSelectToolbar;
